(function () {
    'use strict';

    angular
        .module('uwAgenda.tasks')
        .filter('TaskIdFilter', TaskIdFilterFn);

    TaskIdFilterFn.$inject = [];
    function TaskIdFilterFn() {
        return function (items, id) {
            // if an id is set, only select the task with the id, otherwise show all tasks
            if (id > 0)
            {
                for (var i = 0; i< items.length; i++)
                {
                    // id could be string value -> therefore ==
                    if (items[i].id == id)
                        return [items[i]];
                }

                return [];
            }
            else {
                return items;
            }
        };
    }
})();
